import pic from '../../assets/images/Logo.png';

function Logo({style}) {
    if (!style) {
        style = { position: 'relative', minWidth: '100px', maxWidth:'300px' };
    }
    return (
        <div >
             <a href="https://demo.nationaltalenthub.com/">
              <img src={pic} alt="logo" style={{...style}} />
            </a>
        </div>
    )
}
export default Logo;
